var React = require('react');

function LogoCyanOmg (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#0ff","fillRule":"nonzero","d":"M13.696 69.312H.001V.763h4.54v64.082h9.155v4.467zM13.152 34.77V.858h24.534v4.026H17.652v10.373h18.755v3.978H17.652v11.557h20.792v3.978H13.152z","key":0}),React.createElement("path",{"fill":"#0ff","d":"M13.033 42.06h25.453v4.033H13.033z","key":1})]);
}

LogoCyanOmg.defaultProps = {"fillRule":"evenodd","strokeLinejoin":"round","strokeMiterlimit":"2","clipRule":"evenodd","viewBox":"0 0 39 70"};

module.exports = LogoCyanOmg;

LogoCyanOmg.default = LogoCyanOmg;
